<div class="row no-gutters homepage on-light" *ngIf="userAllowedAccess">

    <h1>
        Report Configuration
    </h1>

    <p>
        The Imago Web Services reporting service is a sophisticated template-driven report generation engine.
    </p>

    <div class="home-buttons">

        <a class="home-btn">
            <div class="icon-hp" [routerLink]="['/templates']">
                <span class="fal fa-file-signature"></span>
            </div>
            <h2>Templates</h2>
            <p>
                Report templates control the ordering and selection of the report sections that make up a report.
            </p>
        </a>

        <a class="home-btn">
            <div class="icon-hp" [routerLink]="['/themes']">
                <span class="fal fa-brush"></span>
            </div>
            <h2>Themes</h2>
            <p>
                Report themes are used by the report generation service to control the look and feel of the documents produced.
            </p>
        </a>

        <a class="home-btn">
            <div class="icon-hp" [routerLink]="['/modules']">
                <span class="fal fa-book"></span>
            </div>
            <h2>Modules</h2>
            <p>
                From here, you can manage your report sections library.
            </p>
        </a>

    </div>

    <div class="background-circles three-options">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>

</div>

<div *ngIf="!userAllowedAccess" class="row no-gutters homepage on-light">
    <h1 style="margin-top: 250px;">
        Access denied
    </h1>
    <p>
        You do not have sufficient permissions to access this page. Please contact your system administrator for help.
    </p>
</div>


